import angularModule from 'Playlists/angularModule/scripts/playlists_module';
import template from 'Playlists/angularModule/views/playlist_map_content_item_icon.html';
import { getPlaylistProgress } from 'ContentProgress';
import cacheAngularTemplate from 'cacheAngularTemplate';
import { playlistIguanaObjectToCamelCase } from '../../playlist';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('playlistMapContentItemIcon', [
    '$injector',

    function factory($injector) {
        const $rootScope = $injector.get('$rootScope');
        const Playlist = $injector.get('Playlist');

        return {
            restrict: 'E',
            templateUrl,
            scope: {
                contentItem: '<',
                locked: '<',
                contentProgress: '<',
                projectsForPlaylists: '<',
            },
            link(scope) {
                if (!scope.contentItem || !$rootScope.currentUser) {
                    scope.numSections = 1;
                    scope.numSectionsFilled = 0;
                    scope.complete = false;
                    return;
                }

                const MIN_SECTIONS = 1;
                const MAX_SECTIONS = 10;

                if (scope.contentItem.isA(Playlist)) {
                    const playlistProgress = getPlaylistProgress(
                        playlistIguanaObjectToCamelCase(scope.contentItem),
                        scope.contentProgress,
                        scope.projectsForPlaylists,
                    );

                    const numItems = playlistProgress.numItems;
                    const numCompletedItems = playlistProgress.numCompletedItems;

                    // clamp the range of sections to ensure proper display in view
                    scope.numSections = Math.max(MIN_SECTIONS, Math.min(MAX_SECTIONS, numItems));

                    // Determine how much to fill the progress 'tower' on the left side of the playlist icon
                    if (playlistProgress.complete) {
                        scope.numSectionsFilled = scope.numSections;
                        scope.complete = true;
                    } else {
                        // interpolate numCompletedItems to be integer from 1 to numSections-1 if more than MAX_SECTIONS items
                        let sectionsToFill = numCompletedItems;
                        if (numCompletedItems > 0 && numItems > MAX_SECTIONS) {
                            // ensure at least 1 section is highlighted
                            // ensure we don't prematurely highlight all sections by using floor
                            sectionsToFill = Math.max(1, Math.floor((numCompletedItems / numItems) * MAX_SECTIONS));
                        }

                        scope.numSectionsFilled = sectionsToFill;
                        scope.complete = false;
                    }
                } else {
                    // Simple path for streams - just check if complete
                    scope.numSections = 1;
                    scope.numSectionsFilled = scope.contentItem.complete ? 1 : 0;
                    scope.complete = scope.contentItem.complete || false;
                }
            },
        };
    },
]);
